module.exports = __webpack_public_path__ + "src/assets/img/light_turn_r.cc563b2e.svg";